module.exports = __webpack_public_path__ + "static/media/infinity.2a55d4bb.png";